module.exports = __webpack_public_path__ + "static/media/view3.0282bb78.jpg";